import React from 'react';
import { NavLink } from 'react-router-dom';
import Img from '../../../../components/Img';
import AppNavbar from '@/AppNavbar';
import { connect } from 'react-redux';
import { withRouter } from '../../../helpers/withRouter';
import { Translation } from "react-i18next";
import EventTopNavBar from '@/app/layout/EventTopNavBar';
import EventbuizzFooter from '../../EventbuizzFooter';

const MasterLayout = ({ children, history, event, ...rest }) => {
    // Robust method to get event ID with multiple fallbacks
    const getEventId = () => {
        // First try: children.props.event.id (for routes that provide it)
        if (children && children.props && children.props.event && children.props.event.id) {
            return children.props.event.id;
        }

        // Second try: Redux event state (passed as prop)
        if (event && event.id) {
            return event.id;
        }

        // Third try: localStorage (for routes like reports)
        try {
            const eventInfo = localStorage.getItem('eventInfo');
            if (eventInfo) {
                const eventData = JSON.parse(eventInfo);
                if (eventData && eventData.id) {
                    return eventData.id;
                }
            }
        } catch (error) {
            console.warn('Could not parse event info from localStorage:', error);
        }

        // Fourth try: URL parameter (if available)
        const urlMatch = window.location.pathname.match(/\/event\/[^/]+\/(.+)/);
        if (urlMatch && urlMatch[1] && !isNaN(urlMatch[1])) {
            return parseInt(urlMatch[1]);
        }

        // Final fallback: return null and don't show the navigation
        console.warn('Could not determine event ID for navigation');
        return null;
    };

    const eventId = getEventId();

    return (
        <Translation>
            {t => (
                <div id="App" className="inner-pages">
                    <AppNavbar cancel="active" children={children} />
                    <main role="main" className="main-section">
                        <div className="container">
                            <div className="wrapper-box">
                                <div className="top-landing-page">
                                    <div className="row d-flex">
                                        <div className="col-3">
                                            <div className="logo innerpageLogo">
                                                <NavLink to={`/`}>
                                                    <Img alt="Plug'n'Play" width="180" src={require("img/logos.svg")} />
                                                </NavLink>
                                            </div>
                                        </div>
                                        {!window.location.pathname.includes('/event/create') && !window.location.pathname.includes('/account/organizer/') && (
                                            <EventTopNavBar children={children} />
                                        )}
                                    </div>
                                </div>
                                <div className="col-12 px-3">
                                    <br></br>
                                    <div className="btn-return-navigation mb-0">
                                        {eventId && (
                                            <NavLink to={`/event/edit/${eventId}`}>
                                                <i className='material-symbols-outlined'>arrow_back</i>{t('M_RETURN_TO_EDIT_EVENT')}
                                            </NavLink>
                                        )}
                                    </div>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </main>
                    <EventbuizzFooter />
                </div>
            )}
        </Translation>
    );
}

class EventFullScreenLayoutRoute extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            default_template_id: (this.props.event !== undefined ? this.props.event.default_template_id : null),
            event: this.props.event,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.event.id !== undefined && state.event.id !== props.event.id) {
            return {
                event: props.event,
                default_template_id: (props.event !== undefined ? props.event.default_template_id : null),
            };
        }
        // Return null to indicate no change to state.
        return null;
    }

    render() {
        const { children, ...rest } = this.props;
        return (
            <MasterLayout history={this.props.history} event={this.props.event}>
                {children}
            </MasterLayout>
        )
    }
};

function mapStateToProps(state) {
    const { event } = state;
    return {
        event
    };
}
export default connect(mapStateToProps)(withRouter(EventFullScreenLayoutRoute));